import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import {CheckCircle} from "@material-ui/icons";
import Field from "../../Field";
import {isStrongPassword} from "../../../lib";
import {signupListItems} from "../../../strings/en-us/text";

export default class SignupFirstStep extends React.Component {
  getPasswordHelp(password) {
    if (!password) {
      return "";
    } else {
      return isStrongPassword(password) ? "Great!" : "Please enter a stronger password.";
    }
  }
  render() {
    const {fetching, data, onChange} = this.props;
    return (
      <div className="row">
        <div className="col-sm-6">
          <List>
            {signupListItems.map(item => (
              <ListItem alignItems="flex-start">
                <CheckCircle color="primary" />
                <div className="signupItemText">{item}</div>
              </ListItem>
            ))}
          </List>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-xs-6">
              <Field
                autoFocus={true}
                disabled={fetching}
                label="First Name"
                name="first_name"
                value={data.first_name}
                onChange={onChange}
              />
            </div>
            <div className="col-xs-6">
              <Field
                disabled={fetching}
                label="Last Name"
                name="last_name"
                value={data.last_name}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Field
                disabled={fetching}
                label="Organization Name"
                name="account_name"
                value={data.account_name}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Field
                disabled={fetching}
                label="Email"
                name="email"
                type="email"
                value={data.email}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12" style={{marginBottom: 16}}>
              <Field
                autoComplete="new-password"
                disabled={fetching}
                label="Password"
                type="password"
                name="password"
                value={data.password}
                onChange={onChange}
                helpText={this.getPasswordHelp(data.password)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Signup/FirstStep/index.jsx